module.exports = {
  "我们为您提供了AI赚币、贷款、新币申购的功能":"我們為您提供了AI賺幣、貸款、新幣申購的功能",
  "AI赚币介绍":"AI基金介绍",
  "账户":"帳戶",
  "盈亏":"盈虧",
  "平仓时间":"平倉時間",
  "止盈止损":"停損",
  "止盈":"止盈",
  "止损":"停損",
  "订单详情":"訂單詳情",
  "取消":"取消",
  "订单时间":"訂單時間",
  "搜索币种":"搜索幣種",
  "选择币种":"選擇貨幣",
  "请输入手数":"請輸入手數",
  "自选":"自選",
  "兑换":"兌換",
  "金额":"金額",
  "得到":"得到",
  "兑换手续费为":"兌換手續費為",
  "立即发送":"立即發送",
  "申请时间":"申請時間",
  "接收数量":"接收數量",
  "手续费":"手續費",
  "充值":"儲值",
  "提现":"提現",
  "合约交易":"合約交易",
  "看涨":"看漲",
  "看跌":"看跌",
  "请输入数量":"請輸入數量",
  "买入":"買入",
  "收益":"效益",
  "杠杆":"槓桿",
  "限价":"限價",
  "市价":"市價",
  "卖出":"賣出",
  "请输入价格":"請輸入價格",
  "开仓成功":"開倉成功",
  "交易账户":"交易帳戶",
  "交易币种":"交易幣種",
  "交易方向":"交易方向",
  "交易数量":"交易數量",
  "开仓价格":"開倉價格",
  "保证金":"保證金",
  "确认":"確認",
  "持仓":"持倉",
  "当前委托":"當前委託",
  "历史记录":"歷史記錄",
  "买涨":"買漲",
  "买跌":"買跌",
  "撤单":"撤銷單",
  "当前价格":"目前價格",
  "平仓":"平倉",
  "总量":"總量",
  "已完成":"已完成",
  "福利专区":"福利專區",
  "请时刻关注福利活动，我们将不定期发布":"請隨時關注福利活動，我們將不定期發布",
  "发行日期":"發行日期",
  "上市日期":"上市日期",
  "请关注":"請關注",
  "公告发布":"公告發布",
  "实际到账":"實際到帳",
  "期权交易":"選擇權交易",
  "首页":"首頁",
  "提示":"提示",
  "请用钱包APP访问":"請用錢包APP訪問",
  "矿池赚币":"礦池賺幣",
  "快捷买币":"快速買幣",
  "更多币种，快捷买币":"更多幣種，快速買幣",
  "去购买":"去購買",
  "公告":"公告",
  "P2P交易":"P2P交易",
  "P2P市场":"P2P市場",
  "链接加密未来":"連結加密未來",
  "开始交易":"開始交易",
  "交易产品":"交易產品",
  "最低手续费":"最低手續費",
  "合作单位":"合作單位",
  "交易品种":"交易品種",
  "更多":"更多",
  "交易品种市场趋势":"交易品種市場趨勢",
  "行情":"行情",
  "交易":"交易",
  "货币":"貨幣",
  "资产":"資產",
  "注册":"註冊",
  "登录":"登入",
  "关于我们":"關於我們",
  "联系我们":"聯絡我們",
  "公告中心":"公告中心",
  "条款说明":"條款說明",
  "用户协议":"使用者協定",
  "隐私协议":"隱私協議",
  "法律声明":"法律聲明",
  "风险告知":"風險告知",
  "服务":"服務",
  "充币":"充幣",
  "提币":"提幣",
  "新币申购":"新幣申購",
  "AI赚币":"AI賺幣",
  "产品":"產品",
  "永续合约":"永續合約",
  "期货合约":"期貨合約",
  "币币交易":"幣幣交易",
  "我的资产":"我的資產",
  "记录":"記錄",
  "可用":"可用",
  "折合":"折合",
  "私募币种":"私募幣種",
  "私募币种上线,您可以在这里买到您觉得有潜力的新币":"私募幣種上線,您可以在這裡買到您覺得有潛力的新幣",
  "名称":"名稱",
  "价格":"價格",
  "4H涨跌":"4H漲跌",
  "成交量":"成交量",
  "操作":"操作",
  "为您的资产保驾护航":"為您的資產保駕護航",
  "行业领先多重安全风控体系,7*24小时全年无休平台监控，全方位保护资产 安全":"業界領先多重安全風控系統,7*24小時全年無休平台監控，全方位保護資產 安全",
  "多重":"多重",
  "安全风控机制":"安全風控機制",
  "全球领先的交易市场":"全球領先的交易市場",
  "轻松创建个人专属资产账户，探索、购买和交易全球的优质 交易品类":"輕鬆建立個人專屬資產帳戶，探索、購買和交易全球的優質 交易類別",
  "品种":"品種",
  "手机PC端均可使用":"手機PC端皆可使用",
  "随时随地开始交易":"隨時隨地開始交易",
  "我们提供强大的图表分析工具：五十多种技术指标和盘面 分析工具。安全可靠、易于使用而又具备高阶投资者使用 的功能特点，成为在线投":"我們提供強大的圖表分析工具：五十多種技術指標與盤面 分析工具。 安全可靠、易於使用但又具備高階投資者使用 的功能特點，成為在線投",
  "点击下载":"點擊下載",
  "安卓市场":"安卓市場",
  "苹果商店":"蘋果商店",
  "私募币种限量上线,您可以在这里买到您觉得有潜力的新币":"私募幣種限量上線,您可以在這裡買到您覺得有潛力的新幣",
  "24H涨跌":"24H漲跌",
  "探索无限可能":"探索無限可能",
  "新币申购功能上线":"新幣申購功能上線",
  "开始使用":"開始使用",
  "AI赚币计划进行中":"AI基金計劃進行中",
  "开始AI赚币,稳定收益,高回报率,让您 躺着赚币":"開始AI基金，穩定收益，高回報率，讓您躺著賺幣",
  "贷款功能上线":"貸款功能上線",
  "当您没钱的时候,您可以申请贷款,最快 当天下发 ":"當您沒錢的時候,您可以申請貸款,最快 當天下發",
  "新币限量上线,您可以在这里买 到您觉得有潜力的新币":"新幣限量上線,您可以在這裡買 到您覺得有潛力的新幣",
  "模拟交易":"模擬交易",
  "限购":"限購",
  "次":"次",
  "关闭模拟":"關閉模擬",
  "数量":"數量",
  "请输入提币地址提币手续费为":"請輸入提幣地址提幣手續費為",
  "提币手续费为":"提幣手續費為",
  "请输入提币地址":"請輸入提幣地址",
  "我已阅读并知晓":"我已閱讀並知道",
  "贷款服务协议":"貸款服務協議",
  "level1": {
     "name": "真實姓名",
     "idcard": "證件類型：",
     "address": "現住地址",
     "bank_number": "銀行卡號",
     "wc": "確定",
     "name_nodata": "姓名不能為空",
     "id_card_nodata": "證件號碼不能為空",
     "address_nodata": "地址不能為空",
     "bank_number_nodata": "銀行卡號不能為空",
     "input-username":"請輸入真實姓名",
     "zjhm":"證件號碼",
     "input-idcard":"請輸入證件號碼",
     "input-address":"請輸入地址",
     "zjlx":"證件類型",
     "qxzzjlx":"請選擇證件類型",
     "sfz":"身份證",
     "hz":"護照",
     "jsz":"駕駛證",
     "lxz":"留學證",
     "zfbzh": "支付寶賬號",
     "qsrzfbzh": "請輸入支付寶賬號",
     "khh": "開戶行",
     "qsrkhh": "請輸入開戶行",
     "yhkh": "銀行卡號",
     "qsryhkh": "請輸入銀行卡號",
     "zfzh": "支付賬戶",
     "qxzzfzh": "請選擇支付賬戶",
     "gjlb": "國家列表",
     "qxzgjlb": "請選擇國家/地區"
   },
  "my":{
   "bindphone":"綁定手機",
   "gqrcode":"掃下面的二維碼圖案或輸入推廣碼，確認註冊",
   "mqrcode":"我的二維碼",
   "as":"設置",
   "pc":"初級認證",
   "ac":"高級認證",
   "smrz":"實名認證",
   "sfyz":"身份驗證",
   "mm":"我的資金",
   "ms":"我要分享",
   "me":"我的收益",
   "zsr":"總收入",
   "mp": "我的推廣",
   "yqhy": "邀請好友",
   "ar":"賬戶記錄",
   "hc":"幫助中心",
   "nodata":"暫無數據",
   "med": "收益明細",
   "aes": "累計收益(USDT)",
   "one": "一代",
   "two": "二代",
   "three": "三代",
   "four": "四代",
   "ones": "一代人數",
   "twos": "二代人數",
   "threes": "三代人數",
   "fours": "四代人數",
   "promotion": "推廣人數",
   "customers": "我的收益",
   "total": "合計(昨日)",
   "usdt": "USDT",
   "wdzc": "我的資產",
   "wdzc1": "我的資產",
   "wyfx": "我要分享",
   "wdsy": "我的收益",
   "wdtg": "我的推廣",
   "zhjl": "賬戶記錄",
   "fbjl": "法幣記錄",
   "zxkf": "聯系客服",
   "wdxx": "我的消息"
  },
 "footer":{
   "home":"首頁",
   "quotation":"行情",
   "currency":"幣幣交易",
   "lever":"合約交易",
   "assets":"資產",
   "my":"我的",
   "lc": "持幣生息"
 },
  home:{
     user:'用使用者的共同選擇',
     start:'開始交易',
     trading:'交易產品',
     fee:'最低手續費',
     co:'合作單位',
     varieties:'交易品種',
     leading:'引領web3創新探索',
     market:'交易品種市場趨勢',
     explore:'探索無限可能',
     newcurrency:'新幣申購功能上線！',
     alimited:'新幣上線，您可以在這裡買到您覺得有潛力的新幣',
     get_start:'開始使用',
     ai_coin:'礦池賺幣計畫進行中',
     ai_text:'開始礦池賺幣，穩定收益，高報酬率，讓你躺著賺幣',
     loan:'贷貸款功能上線',
     loan_text:'當您沒錢的時候，您可以申請貸款，最快當天下發',
     mobile_pc:'手機PC端護士使用',
     pc_anytime:'隨時隨地開始交易：',
     pc_text:'我們提供強大的圖表分析工具：五十多種技術指標和盤面分析工具。安全可靠、易於使用的槓桿高槓桿利用的功能特點，成為線上投資的標準平台。',
     mobile_down:'點擊下載',
     mobile_android:'安卓市場',
     mobile_ios:'蘋果商店',
     open_text:'三分之一即可申請真實交易帳戶或免費體驗模擬帳戶',
     open_account:'一個帳戶',
     tocomplete:'去完成',
     walletlogin:'錢包登入',
    thedoor:'投資理財之門',
    weare:'我們是管理數位、外匯最值得信賴的地方。',
    emailaddress:'Email地址',
    allprices:'全部價格',
    chart:'貴金屬走勢圖',
    gold:'Blkketf是一個非常實用的交易軟體,您可以直接在首頁查看走勢圖',
    more:'更多實用的功能',
    weprovide:'我們為您提供了礦池賺幣、貸款、新幣申購的功能',
    zzc:'總資產',
    gmjy:'您可以購買少量加密貨幣，立即開始交易'
  },
  propagate:{
    ai:'智慧礦池介紹',
    how:'基金加盟经理简介',
    brick:'搬磚幣種',
  },
  propagatebuy:{
    joinai:'加入智慧礦池',
    risk:'0風險 收益穩定',
    daily:'每日收益將發放到您的USDT錢包帳戶',
    zero:'您的託管資金0風險',
    youcan:'您可以在任何時間取回您的資金',
    airobot:'AI機器人365*24小時不間斷地工作',
  },
 "index":{
   "wdzc":"我的資產 (USDT)",
   "xsbk":"新手必看",
   "dlhkck":"登錄後可以查看",
   "dl":"登錄查看",
   "zxkf":"聯系客服",
   "function":"功能服務",
   "legal":"法幣交易",
   "legaltxt":"用法定貨幣購買數字資產",
   "levertxt":"數倍於原始資金的的投資",
   "c2c":"c2c交易",
   "c2ctxt":"雙向交易 套期保值",
   "increase":"漲幅榜",
   "innovate":"創新區",
   "myshop":"我的商鋪",
   "order":"訂單管理",
   "myc2c":"我交易的c2c",
   "usercenter":"個人中心",
   "myshare":"我的分享鏈接",
   "releasec2c":"發布c2c",
   "language":"語言切換",
   "security":"安全中心",
   "pay":"收款方式",
   "bindaddress":"綁定提幣地址",
   "address":"提幣地址",
   "aboutus":"關於我們",
   "logout":"登出",
   "vol":"24H量",
   "jc":"JC兌換BEAU",
   "kjcb": "快捷充幣",
   "zcbz": "BTC、USDT..."
 },
 "transaction":{
   "buy":"買入",
   "sell":"賣出",
   "pwd":"交易密碼",
   "inputpass":"輸入交易密碼",
   "inputnum":"輸入數量",
   "limit":"限價",
   "avaiable":"可用",
   "turnover":"交易額",
   "handicap":"盤口",
   "number":"數量",
   "nonumber":"未完成數量",
   "numbered":"已完成數量",
   "price":"價格",
   "marketprice":"市價",
   "cancel":"取消",
   "total":"全站交易",
   "time":"時間",
   "nomore":"暫無更多",
   "nodata":"暫無記錄",
   "getmore":"加載更多",
   "mycommission":"我的委托",
   "currentbuy":"當前委托(買入)",
   "currentsell":"當前委托(賣出)",
   "his":"歷史委托(已完成)",
   "currency":"幣種",
   "option":"操作",
   "wtime":"完成時間",
   "wnumber":"完成數量",
   "wprice":"完成價格"
 },
 "mk":{
   "high":"高",
   "low":"低",
   "vol":"24H量",
   "newPrice":"最新價",
   "product":"產品",
   "name":"名稱",
   "rank":"漲幅榜"
 },
 "deals":{
   "issue_time":"發行時間",
   "issue_number": "發行數量",
   "white_book": "白皮書",
   "weburl": "官網",
   "video_url": "視頻介紹",
   "introduction":"簡介",
   "onhand":"1手等於",
   "position": "當前持倉",
   "leverorder":"杠桿下單",
   "leverposition":"杠桿持倉",
   "inputprice":"輸入價格",
   "inputmul":"輸入倍數",
   "selectmul":"選擇倍數",
   "onehand":"1手等於",
   "hand":"交易手數",
   "marketval":"合約市值",
   "bond":"保證金",
   "service":"服務費",
   "balance":"余額",
   "type":"類型",
   "risk":"風險率",
   "total":"持倉總盈虧：",
   "onekey":"一鍵平倉",
   "makemore":"(做多)",
   "makeless":"(做空)",
   "current":"當前委托",
   "all":"全部",
   "weing":"委托中",
   "tding":"交易中",
   "ping":"平倉中",
   "pied":"已平倉",
   "ceiled":"已撤單",
   "weprice":"委托價",
   "oprice":"開倉價",
   "nowprice":"當前價",
   "zyprice":"止盈價",
   "zsprice":"止損價",
   "canbond":"可用保證金",
   "optime":"開倉時間",
   "pgtime":"平倉時間",
   "znum":"折合數量",
   "gprice":"隔夜費",
   "pcang":"平倉",
   "revoke":"撤單",
   "fee":"手續費",
   "you":"以當前最優價格交易"
 },
 "assets":{
   "bzxz":"幣種選擇",
   "copy": "復製",
   "currency":"幣幣",
   "lever":"合約",
   "legal":"法幣",
   "curAccount":"幣幣賬戶",
   "total":"資產折合(USDT)",
   "leverAccount":"合約賬戶",
   "legalAccount":"法幣賬戶",
   "avaiable":"可用",
   "lock":"凍結",
   "conversion":"折合",
   "exact":"交易賬戶",
   "transfer":"劃轉",
   "num":"數量",
   "time":"時間",
   "record":"記錄",
   "caidata":"財務記錄",
   "from":"從",
   "to":"到",
   "transnum":"劃轉數量",
   "all":"全部",
   "canuse":"可用",
   "pmin":"請輸入最低劃轉數量",
   "cmoney":"充幣",
   "tmoney":"提幣",
   "caddress":"充幣地址",
   "copyaddress":"復製地址",
   "a01":"請勿向上述地址充值任何非",
   "a02":"資產，",
   "a03":"否則資產將不可找回。",
   "a04":"充幣僅支持simple send的方法，使用其他方法的充幣暫時無法上賬，請您諒解。",
   "a05":"您充值至上述地址後，需要整個網絡節點的確認，1次網絡確認後到賬，6次網絡確認可提幣。",
   "a06":"最小充值金額：",
   "a07":"小於最小金額的充值將不會上賬且無法退回。",
   "a08":"您的充值地址不會經常改變，可以重復充值;如有更改，我們會盡量通過網絡公告或郵件通知您。",
   "a09":"請務必確認電腦及瀏覽器安全，防止信息被篡改或泄露。",
   "taddress":"提幣地址",
   "taddressm":"請輸入提幣地址",
   "padd":"輸入或長按粘貼地址",
   "rate":"手續費",
   "dnum":"到賬數量",
   "more":"加載更多",
   "nodata":"暫無記錄",
   "search":"搜索幣種",
   "yczc":"隱藏為0的資產"
 },
 "td":{
   "drecord":"訂單記錄",
   "orecord":"已完成訂單記錄",
   "filter":"篩選",
   "tdtype":"交易類型",
   "buy":"購買",
   "sell":"出售",
   "wantbuy":"求購",
   "dstatus":"訂單狀態",
   "nofinish":"未完成",
   "finished":"已完成",
   "ceiled":"已取消",
   "payed":"已付款",
   "waitPay":"待付款",
   "reset":"重置",
   "confirm":"確定",
   "time":"時間",
   "num":"數量",
   "tdtotal":"交易總額",
   "call":"聯系對方",
   "buyer":"買家",
   "seller":"賣家",
   "Sprice":"單價",
   "price":"價格",
   "ptime":"下單時間",
   "cnum":"參考號",
   "tdceil":"取消交易",
   "sureReceive":"確認已收款",
   "conPay":"付款確認",
   "ppay":"請付款",
   "paynext":"請向以下賬戶付款",
   "tdPrice":"交易單價",
   "tdNum":"交易數量",
   "payInfo":"付款信息",
   "accountInfo":"賬號信息",
   "receiver":"收款人",
   "open":"開戶行",
   "pcnum":"打款時請務必填寫參考號",
   "imPay":"我已付款,點擊確認",
   "tdAttion":"交易提醒",
   "odCeil":"取消訂單",
   "at01":"您的匯款將直接進入賣家賬戶,交易過程中賣家出售的數字資產由平臺托管保護。",
   "at02":"請在規定時間內完成付款，並務必點擊「我已付款」，賣家確認收款後，系統會將數字資產劃轉到您的賬戶。",
   "at03":"如果買家當日取消訂單達3次，將會被限製當日的買入功能。",
   "sureImpay":"請確認您已向賣家付款",
   "badClick":"惡意點擊將直接凍結賬戶",
   "notpay":"我還沒有付款給對方",
   "sureDpay":"請確認買家已向您付款",
   "sureCeil":"確認取消交易",
   "notCeil":"如果您已向賣家付款，請千萬不要取消交易",
   "dover":"訂單已完成，無法查看支付信息",
   "cover":"訂單已取消，無法查看支付信息",
   "payFast":"付款確認後請盡快向賣家付款",
   "payClick":"如您已向賣家轉賬付款，請務必點擊右下角「我已付款」按鈕，否則有可能造成資金損失。",
   "pwait":"請等待買家付款",
   "pwd":"交易密碼",
   "ppwd":"請輸入交易密碼",
   "sure":"確定",
   "alipay":"支付寶",
   "wechat":"微信",
   "bank":"銀行卡",
   "realName":"真實姓名",
   "knum":"卡號",
   "pprice":"請輸入單價",
   "pnum":"請輸入數量",
   "min":"最小交易量",
   "pmin":"請輸入最小交易量",
   "max":"最大交易量",
   "pmax":"請輸入最大交易量",
   "buyNum":"購買數量",
   "currency":"幣種",
   "pmethod":"請選擇支付方式",
   "choose":"請選擇",
   "mysells":"我的出售",
   "mybuys":"我的求購",
   "pcoin":"請選擇貨幣單位"
 },
 "fat":{
   "mybuy":"我要買",
   "mysell":"我要賣",
   "ceil":"取消",
   "buy":"購買",
   "sell":"出售",
   "forsell":"出售需求",
   "forbuy":"購買需求",
   "price":"單價",
   "bprice":"按價格購買",
   "bnum":"按數量購買",
   "pbtotal":"請輸入欲購買法幣總額",
   "pstotal":"請輸入欲出售法幣總額",
   "pbnum":"請輸入欲購買數量",
   "psnum":"請輸入欲出售數量",
   "allbuy":"全部買入",
   "allsell":"全部賣出",
   "limit":"限額",
   "tdtotal":"交易總額",
   "autoceil":"s自動取消",
   "num":"數量",
   "submit":"下單",
   "pwd":"交易密碼",
   "ppwd":"請輸入交易密碼",
   "sure":"確認下單",
   "reTime":"認證商家 | 註冊時間 ",
   "release":"發布",
   "allOrder":"總成單",
   "dayOrder":"30日成單",
   "overOrder":"完成單",
   "rate":"完成率",
   "auPhone":"手機認證",
   "auName":"實名認證",
   "auHigh":"高級認證",
   "sellLine":"在線出售",
   "buyLine":"在線購買",
   "myshop":"我的商鋪",
   "mybalance":"商家余額"
 },
 "auth":{
   "bh": "駁回",
   "bhr": "您的申請被駁回，原因如下：",
   "mycenter":"個人中心",
   "test":"身份驗證",
   "gotest":"去認證",
   "testing":"審核中",
   "tested":"已認證",
   "t1":"認證後可提升提幣額度",
   "t2":"認證後可進行c2c交易",
   "t3":"認證後可進行法幣交易",
   "name":"姓名",
   "account":"賬戶",
   "number":"證件號",
   "pname":"請輸入姓名",
   "pnum":"請輸入證件號",
   "id_card_face": "請上傳身份證正面",
   "id_card_back": "請上傳身份證反面",
   "upimg":"請上傳證件正反面，以及手持證件照正面照片。",
   "updata":"提交",
   "updata_again":"重新提交"
 },
 "code":{
   "mycode":"我的推廣碼",
   "code":"推廣碼",
   "qrcode":"掃上面的二維碼圖案或輸入推廣碼，確認註冊",
   "notice":"公告",
   "about":"相關新聞"
 },
 "safe":{
   "title":"賬戶安全",
   "center":"安全中心",
   "qchc":"清除緩存",
   "yysz":"語言設置",
   "ssms":"深色模式",
   "gywm":"關於我們",
   "lgpwd":"登錄密碼",
   "tkmm":"提幣密碼",
   "paypwd":"支付密碼",
   "resetpwd":"修改密碼",
   "paccount":"請輸入手機號或郵箱",
   "next":"下一步",
   "reset":"修改",
   "stest":"安全驗證",
   "ceil":"取消",
   "pcode":"請輸入驗證碼",
   "send":"發送",
   "sure":"確認",
   "newPwd":"重新設置密碼",
   "len":"密碼需要6-20個字符",
   "ppwd":"請輸入密碼",
   "reppwd":"請再次輸入密碼",
   "repwd":"重置密碼",
   "zpwd":"交易密碼"
 },
 "met":{
   "add":"添加方式",
   "open":"開戶行名稱",
   "bank":"銀行賬號",
   "realname":"真實姓名",
   "alipay":"支付寶賬號",
   "wename":"微信昵稱",
   "wechat":"微信賬號",
   "save":"保存",
   "popen":"請輸入開戶行名稱",
   "pbank":"請輸入開戶行賬號",
   "pname":"請輸入真實姓名",
   "palipay":"請輸入支付寶賬號",
   "pwename":"請輸入微信昵稱",
   "pweaccount":"請輸入微信賬號"
 },
 "ads":{
   "tas":"提幣地址",
   "address":"地址",
   "noads":"您還沒有地址",
   "adds":"地址",
   "padd":"提幣或粘貼地址",
   "remark":"備註",
   "cel":"刪除"
 },
 "call":{
   "callme":"聯系我們",
   "Privacy":"隱私政策"
 },
 "jc":{
   "title":"JC積分兌換BEAU平臺",
   "bind":"綁定賬號",
   "balance":"JC余額",
   "cannum":"可用JC數量:",
   "new":"BEAU最新價:",
   "exnum":"兌換數量:",
   "pnum":"請輸入JC數量",
   "canex":"可兌換BEAU數量:≈",
   "exnow":"立即兌換",
   "record":"兌換記錄",
   "exprice":"兌換價格:",
   "extime":"兌換時間",
   "not":"可用積分數量不足",
   "usenum":"使用JC數量",
   "paccount":"請輸入賬號",
   "ppwd":"請輸入密碼",
   "gotd":"去交易"
 },
 "lg":{
   "welcome":"您好！歡迎登錄",
   "hsa": "已有賬號?",
   "lgs":"登錄",
   "lgbt":"登錄",
   "qbdl":"錢包登入",
   "lgtel":"手機登陸",
   "lgeml":"郵箱登陸",
   "paccount":"手機號或郵箱",
   "ppwd":"請輸入密碼",
   "ppwd2":"請確認密碼",
   "pcode":"請輸入驗證碼",
   "qsryqm": "請輸入邀請碼",
   "mepwd":"記住密碼",
   "noaccount":"還沒有賬號？",
   "qregister":"去註冊",
   "register":"註冊",
   "phregister":"手機註冊",
   "emregister":"郵箱註冊",
   "noset":"註冊後不能修改",
   "pphone":"請輸入手機號",
   "next":"下一步",
   "have":"已有賬號？",
   "ceil":"取消",
   "msgtest":"短信驗證",
   "send":"獲取驗證碼",
   "sure":"確定",
   "email":"請輸入郵箱地址",
   "emtest":"郵箱驗證",
   "scode":"發送驗證碼",
   "pemcode":"請輸入驗證碼",
   "ppcode":"請輸入手機驗證碼",
   "ftpwd":"忘記密碼？",
   "ftpwds":"忘記密碼",
   "ptext":"請輸入手機號或郵箱",
   "safetest":"安全驗證",
   "sjh":"手機號",
   "yzm":"驗證碼",
   "mm":"密碼",
   "qrmm":"確認密碼",
   "mmcd":"密碼長度8-12位",
   "language":"語言切換",
   "kjzc": "聯系客服快速註冊",
   "kjzc1": "無法接收驗證碼？",
   "kjzc2": "快捷註冊",
   "wyzx": "我已知曉",
   "qtxyxzh": "提示：請填寫有效的電子郵件地址或手機號，可用於找回密碼"
 },
 "gjrz":{
   "title":"高級認證",
   "t1":"1、支持小於8M的JPG、JPEG或PNG格式圖片。",
   "t2":"2、證件照要求清晰，不允許任何修改和遮擋，必須看清人像，證件號和姓名。",
   "t3":"3、照片需免冠，建議未化妝，手持證件人的五官清晰可鑒，完整需露出手臂。",
   "t4":"確定",
   "bh":"駁回",
   "shz":"審核中",
   "shtg":"審核通過",
   "nyrzcg":"您已認證成功",
   "sczjz":"上傳證件照",
   "sczjzmz": "上傳證件正面照",
   "sczjbmz": "上傳證件背面照",
   "scgrqmz": "上傳手持證件照"
 },
 "chongzhi":{
   "title":"充幣",
   "cbjl": "充幣記錄",
   "t1":"數量",
   "t2":"請輸入數量",
   "t3":"憑證描述(選填)",
   "t4":"請輸入描述",
   "t5":"憑證圖片",
   "t6":"確定",
   "t7":"鏈名稱",
   "t8":"二維碼",
   "t9":"保存二維碼",
   "t10":"充幣地址",
   "t11":"復製",
   "zy": "註意",
   "tips1": "請勿向上述地址充值任何非本幣種資產否則資產不可找回",
   "tips2": "1.錢包/平臺的兼容：即對該網絡支持；如目標平臺不支持您的提幣網絡，將導致資產無法找回。",
   "tips3": "2.您充值網絡和目標平臺是一致的；如您選擇了目標地址是以太坊網絡，但充值選擇了TRC20智能鏈，您或將無法找回您的數字資產。",
   "tips4": "3.充值前確保您的地址、金額正確。",
   "tips5": "溫馨提示：由於區塊網絡匿名和私密，一旦輸入錯誤信息，您將損失對應資產。請務必仔細核對您的充值地址及數量"
 },
 "tibi":{
   "title":"提幣",
   "tbjl":"提幣記錄",
   "t1":"提幣地址",
   "t2":"請輸入提幣地址",
   "t3":"提幣數量",
   "qsrtbsl":"請輸入提幣數量",
   "t4":"最低提幣",
   "t5":"交易密碼",
   "t6":"請輸入交易密碼",
   "t7":"手續費",
   "t8":"到賬數量",
   "t9":"確定",
   "sc":"刪除",
   "bj":"編輯",
   "bq": "標簽(Memo)",
   "qsrbq":"請輸入標簽",
   "yhktx":"銀行匯款",
   "yhmc": "銀行名稱",
   "qsryhmc": "請輸入銀行名稱",
   "yhzh": "銀行賬號",
   "qsryhzh":"請輸入銀行賬號",
   "gjhkdm": "國際匯款代碼",
   "qsrgjhkdm":"請輸入國際匯款代碼",
   "yhdz": "銀行地址",
   "qsryhdz":"請輸入銀行地址",
   "skrxm": "收款人姓名",
   "qsrskrxm":"請輸入收款人姓名",
   "skrdh": "收款人電話",
   "qsrskrdh":"請輸入收款人電話",
   "skrdz": "收款人地址",
   "qsrskrdz":"請輸入收款人地址"
 },
 "huazhuan":{
   "title":"USDT劃轉",
   "t1":"幣幣賬戶余額",
   "t2":"合約賬戶余額",
   "t3":"劃轉數量",
   "t4":"請輸入數量",
   "t5":"劃轉方向",
   "t6":"從",
   "t7":"幣幣賬戶",
   "t8":"至",
   "t9":"合約賬戶",
   "zf": "支付",
   "ky": "可用",
   "dd": "得到",
   "qbdh": "全部兌換",
   "t10":"確定"
 },
 "banner":{
   "title": "詳情"
 },
 "download":{
   "t1": "移動交易，隨時隨地",
   "xz": "下載"
 },
 "xgdlmm":{
   "title": "修改登錄密碼",
   "zh":"賬號",
   "zhts":"手機號或郵箱",
   "yzm":"驗證碼",
   "yzmts":"請輸入驗證碼",
   "hqyzm":"獲取驗證碼",
   "mm":"密碼",
   "mmts":"密碼長度6-12位",
   "qrmm":"確認密碼",
   "send":"發送",
   "qr":"確認"
 },
 "sztkmm":{
   "title":"設置交易密碼",
   "dlmm":"登錄密碼",
   "dlmmts":"請輸入登錄密碼",
   "xmm":"新密碼",
   "mmts":"密碼長度6位數字",
   "qrmm":"確認密碼",
   "qr":"確認",
   "qd": "確定",
   "sztkts": "提示：請到安全中心設置交易密碼"
 },
 "rule":{
   "title":"产品介绍",
   "title2":"規則",
   "title3":"活動"
 },
 "news":{
   "title":"我的消息",
   "ckxq":"查看詳情",
   "gg":"公告"
 },
 "xsbk":{
   "title":"新手必看"
 },
 "search":{
   "qx":"取消",
   "rmss":"熱門搜索",
   "ss": "搜索"
 },
 "wdtg":{
   "title": "好友齊歡聚",
   "yq": "邀請",
   "zyj": "賺傭金",
   "wdyqlj":"我的邀請鏈接",
   "wdyqm":"我的邀請碼",
   "schbyq":"生成海報邀請",
   "ljtgsy":"累計推廣收益",
   "ljkh":"累計客戶(人)",
   "tkrs":"邀請人數",
   "ljyj":"累計傭金",
   "yjmx":"傭金明細",
   "ljyjjl":"累計傭金獎勵(usdt)",
   "ljsy":"累計收益",
   "ljyqjl":"累計邀請獎勵(usdt)",
   "fxd":"分享到",
   "wxhy":"微信好友",
   "wxpyq":"微信朋友圈",
   "bctp":"保存圖片",
   "qx":"取消",
   "t1": "邊挖礦 邊抄幣",
   "t2": "盈利全歸你",
   "t3": "長按圖片識別或掃一掃"
 },
 "bzhl":{
   "title":"AI基金",
   "gz":"規則",
   "tgdd":"托管訂單",
   "zztgdzj":"正在托管的資金",
   "yjjrsy":"預估日收益",
   "ljsy":"累計收益",
   "tgzdd":"托管中訂單",
   "cljxcp":"策略競選產品",
   "dbxe":"單筆限額",
   "rsyl":"日收益率",
   "zq":"周期",
   "qmr":"立即購買",
   "bbzhzc": "賬戶資產",
   "zcc": "總持倉(USDT)",
   "dd":"訂單",
   "buy":"買入",
   "jxcp":"精選產品",
   "ckdd":"查看訂單",
   "gd":"更多",
   "xzbzts": "簡單，安全。可選擇多種幣種進行派息",
   "qtbz": "其它基金"
 },
 "bzhlgm":{
   "title":"搬磚獲利",
   "bzhld":"搬磚獲利得usdt",
   "qtzq":"USDT7天周期",
   "rsyl":"日收益率(%)",
   "lczq":"理財周期",
   "dbxe":"單筆限額",
   "pxsj":"派息時間",
   "mr":"每日",
   "dqfh":"到期返還",
   "tgzj":"托管資金",
   "tqsh":"提取贖回",
   "yjsy":"預計收益(USDT)",
   "kyzc":"可用資產(USDT)",
   "cpjs":"產品介紹",
   "tgje":"托管金額",
   "qsrtgje":"請輸入托管金額",
   "qb":"全部",
   "rm":"立即購買",
   "cpzq":"產品周期",
   "jxr":"計息日",
   "jiexr":"結息日",
   "yjdzr":"預計到賬日",
   "gz":"了解規則以及權益"
 },
 "bzhlwdtg":{
   "title":"訂單狀態",
   "tgz":"托管中",
   "ywc":"已完成",
   "ysh":"已贖回",
   "tgje":"托管金額/周期天數",
   "rsyl":"日收益率",
   "yhl":"已獲利/剩余天數",
   "xdsj":"下單時間",
   "sh":"贖回",
   "ddxq":"訂單詳情",
   "ddh":"訂單號"
 },
 "bzjj":{
   "t1": "天天賺不停",
   "t2": "搬磚是通過將USDT托管給平臺，由平臺的專業團隊進行搬磚權利，參與者在資金托管期間可獲得平臺的搬磚收入分成",
   "cpld": "產品亮點",
   "scsq": "隨存隨取",
   "pxzq": "派息周期",
   "mtxf": "每天下發",
   "hqlx": "活期利息",
   "zj": "100%資金",
   "aqbz" :"安全保障",
   "jjrsy": "節假日收益",
   "sybjd":"收益不間斷",
   "bjd": "不間斷",
   "cgcrh": "成功存入後",
   "dtqx": "當天起息",
   "jglz": "舉個例子",
   "syjs": "收益計算",
   "cont1": "會員在平臺存入了10000U，選擇了周期為七天，日收益率為0.3%~0.5%的理財產品，則每天的收益如下：",
   "cont2": "最低：10000U× 0.3%-30U",
   "cont3": "最高：10000U× 0.5%-50U",
   "cont4": "既：7天後可以獲得210U-350U的收益，收益每日下發，下發的收益可隨時存取，存入的本金，到期滿後，自動返回自您的錢包賬戶。",
   "gywyj": "關於違約金",
   "cont5": "若您希望轉出未到期的本金，則會產生違約金，違約金=違約結算比例*剩余天數*投資數量。",
   "cont6": "舉例：該產品的違約結算比例為0.4%，剩余3天到期，投資數量為1000，則違約金=0.4%*3*1000=12U，實際退還本金為1000U-12U=988U",
   "wycy": "我要參與"
 },
 "zyzs":{
   "title":"止盈止損",
   "zy":"止盈",
   "zs":"止損",
   "qsrzyjg":"請輸入止盈價格",
   "qsrzsjg":"請輸入止損價格",
   "cfjglx":"觸發價格類型：",
   "zsjg":"指數價格",
   "scjg":"市場價格",
   "pcfs":"平倉方式：",
   "kpcw":"可平倉位",
   "qbcw":"全部倉位",
   "wxts":"溫馨提示：",
   "cont": "市場平倉，可能會因為行情波動劇烈等問題導致一定概率市價單下單失敗，無法成功止盈止損。",
   "qr":"確認"
 },
 "bbjy":{
   "mr":"買入",
   "mc":"賣出",
   "mai":"買",
   "sell":"賣",
   "xj":"限價",
   "sj":"市價",
   "pk":"盤口",
   "jg":"價格",
   "sl":"數量",
   "mrl":"買入量",
   "ss":"數量",
   "mcl":"賣出量",
   "ky":"可用",
   "km":"可買",
   "ksell":"可賣",
   "jye":"交易額",
   "dqwt":"當前委托",
   "lswt":"歷史委托",
   "jj":"簡介",
   "wtzl":"委托總量",
   "wtjg":"委托價格",
   "ycjl":"已成交量",
   "cjjj":"成交均價",
   "cd":"撤單",
   "xd":"下單",
   "ywc":"已完成",
   "ycd":"已撤單",
   "wqcj":"完全成交",
   "zx":"自選",
   "scjg":"市場價格",
   "fhsj":"發行時間",
   "fhsl":"發行數量",
   "bps":"白皮書",
   "gw":"官網",
   "qx":"取消"
 },
 "hyjy":{
   "mai":"買",
   "sell":"賣",
   "kc":"開倉",
   "pc":"平倉",
   "cc":"持倉",
   "kp":"可平",
   "kpc":"可平空",
   "kcc":"可持倉",
   "kkd":"可開多",
   "kpd":"可平多",
   "kkk":"可開空",
   "xj":"限價",
   "sj":"市價",
   "xjwt":"限價委托",
   "sjwt":"市價委托",
   "pk":"盤口",
   "jg":"價格",
   "sl":"數量",
   "gg":"杠桿",
   "tzgg":"調整杠桿",
   "ggbs": "杠桿倍數",
   "mrl":"買入量",
   "ky":"可用",
   "jye":"交易額",
   "dqwt":"當前委托",
   "lswt":"歷史委托",
   "ptwt":"普通委托",
   "dqwtmr":"當前委托(買入)",
   "dqwtmc":"當前委托(賣出)",
   "hywt":"合約委托",
   "jj":"簡介",
   "wtzl":"委托總量",
   "wtjg":"委托價格",
   "ycjl":"已成交量",
   "cjjj":"成交均價",
   "cd":"撤單",
   "xd":"下單",
   "qbcd":"全部撤單",
   "wqcj":"完全成交",
   "ywc":"已完成",
   "ycd":"已撤單",
   "zx":"自選",
   "scjg":"市場價格",
   "fhsj":"發行時間",
   "fhsl":"發行數量",
   "bps":"白皮書",
   "gw":"官網",
   "mrzd":"買入做多",
   "mrpk":"買入平空",
   "mczk":"賣出做空",
   "mcpd":"賣出平多",
   "mrkdkz":"買入開多(看漲)",
   "mrpkkz":"買入平空(看漲)",
   "mckkkd":"賣出開空(看跌)",
   "mcpdkd":"賣出平多(看跌)",
   "yxhy":"永續合約",
   "dc":"多倉",
   "kcjj":"開倉均價(BUSDT)",
   "wsxyl":"未實現盈利(BUSDT)",
   "ygqpj":"預估強評價(BUSDT)",
   "syl":"收益率",
   "cwbzj":"倉位保證金(BUSDT)",
   "cw":"倉位(張)",
   "cwjz":"倉位價值(BUSDT)",
   "bzjl":"保證金率",
   "kpz":"可平(張)",
   "bdzs":"標的指數",
   "tzbzj":"調整保證金",
   "zyzs":"止盈止損",
   "zjbzj":"增加保證金",
   "jsbzj":"減少保證金",
   "tyhy":"體驗合約",
   "ccz":"持倉(張)",
   "cwbzjt":"倉位保證金(TBTC)",
   "zdzjbzj":"最多增加保證金(TBTC)",
   "zjbzjt":"增加保證金(TBTC)",
   "zhang":"數量",
   "qblx":"全部類型",
   "qb":"全部",
   "ccjg":"持倉價格",
   "ccsl":"持倉數量",
   "yk":"盈虧",
   "ccsj":"持倉時間",
   "zy":"止盈",
   "zs":"止損",
   "zje":"總金額",
   "kcs":"開倉數",
   "kcjg":"開倉價格",
   "ss":"手數",
   "hand":"1手 =",
   "qx":"取消",
   "qr":"確認"
 },
 "kxt":{
   "gao":"高",
   "di":"低",
   "wtgd":"委托掛單",
   "cj":"成交",
   "jj":"簡介",
   "sj":"時間",
   "fx":"方向",
   "jg":"價格",
   "sl":"數量",
   "mr":"買入",
   "mc":"賣出",
   "mp":"買盤",
   "sp":"賣盤",
   "slb":"數量",
   "fhsj":"發行時間",
   "fhsl":"發行數量",
   "bps":"白皮書",
   "gw":"官網",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd": "More",
   "ft":"副圖",
   "zt":"主圖",
   "sdt":"深度圖",
   "zx":"自選",
   "djck": "點擊查看"
 },
 "zhjl":{
   "cbtb":"充幣提幣",
   "jymx":"交易明細",
   "tgyj":"推廣傭金",
   "wwc": "未完成",
   "ywc": "已完成"
 },
 "zwsj":{
   "title":"暫無數據"
 },
 "bzxz":{
   "title":"選擇幣種"
 },
 "jghy":{
   "jghy": "期貨合約",
   "yxhy": "永續合約",
   "mz": "買漲",
   "md": "買跌",
   "gmj": "購買價",
   "jsj": "結算價",
   "xj": "現價",
   "fx": "方向",
   "sl": "數量",
   "jgsj": "交割時間",
   "gb": "關閉",
   "jxxd": "繼續下單",
   "cclb": "持倉列表",
   "zc": "在持",
   "lscc": "歷史持倉",
   "qblx": "全部類型",
   "yk": "盈虧",
   "ddqr": "訂單確認",
   "dqsj": "到期時間",
   "jssj": "結算時間",
   "sy": "收益",
   "tzje": "投資金額",
   "zdje": "投資金額大於0",
   "kyye": "可用余額: ",
   "kyye2": "可用余額",
   "sxf": "手續費：",
   "sxfl": "手續費",
   "jypz": "名稱",
   "jyfx": "交易方向",
   "qrxd": "確認下單",
   "fs": "more",
   "dqye": "當前余額"
 },
 "kjmb":{
   "title":"快捷買幣",
   "gm": "購買USDT",
   "wxts": "溫馨提示：",
   "wxts-copy": "請復製USDT地址，您需要使用該地址購買USDT。",
   "copy": "復製",
   "ljmb": "立即買幣",
   "buy": "購買",
   "cs": "出售",
   "qx": "取消",
   "gmsl": "購買數量",
   "cssl": "出售數量",
   "qsrgmsl": "請輸入購買數量",
   "qsrcssl": "請輸入出售數量",
   "qxzzffs": "請選擇支付方式",
   "yhk": "銀行卡",
   "wx": "微信",
   "zfb": "支付寶",
   "jg": "價格",
   "kyye": "可用余額：",
   "zxjysl": "最小交易數量：",
   "ts1": "1.買賣商家均為平臺認證商家，提供24小時服務。",
   "ts2": "2.如訂單產生糾紛，請立即聯系客服進行處理。",
   "fzcg": "復製成功"
 },
 "tips":{
   "jymm": "交易密碼",
   "szjymm": "設置交易密碼",
   "qsrjymm": "請輸入交易密碼",
   "jymmts": "請到安全中心設置交易密碼"
 },
 "xyf":{
   "title": "信用分",
   "pgsj": "評估時間"
 },
 "dzrz":{
   "title": "地址認證",
   "sdddz":"水電單地址",
   "tips":"您需要填寫地址信息和提交水電費或者寬帶地址的賬單",
   "tpsc": "賬單圖片上傳",
   "ts": "提示：您需要填寫地址信息和提交水電費或者寬帶地址的賬單",
   "qsczdtp":"請上傳賬單圖片"
 },
  "newReg":{
   "sjh": "手機號",
   "yx": "郵箱",
   "yqm": "邀請碼",
   "yqm2": "邀請碼（可選）",
   "cjzh": "創建賬戶",
   "sysjhzyx": "使用手機號/電子郵箱註冊",
   "sj": "手機",
   "yhxy": "《用戶協議》",
   "yhxy2": "我已閱讀並同意《用戶協議》"
 },
 "mbwt":{
   "title": "密保問題設置",
   "mbwt": "密保問題",
   "qtxda": "請填寫答案",
   "qsrxmm": "請輸入新密碼",
   "sydqmmcz": "使用當前密碼重置",
   "zhmm": "密保問題找回密碼",
   "ysz": "已設置",
   "tg": "跳過",
   "tj": "提交",
   "zyts": "重要提示：",
   "zytsCont": "請勿泄露密保答案和驗證碼，並牢記密保問題，這將有助於您找回密碼"
 },
 "xbsg":{
   "title": "新幣專區",
   "wdsg": "我的申購",
   "scts": "鎖倉天數：",
   "sy": "剩余",
   "ljsg": "立即申購",
   "ysk": "已售空",
   "xzjdy": "現在就訂閱",
   "dy": "訂閱",
   "fxjg": "發行價格",
   "fxl": "發行量",
   "ssrq": "上市日期",
   "yxqx": "有效期限",
   "qsrsl": "請輸入數量",
   "syl": "剩余量",
   "sgrq": "申購日期",
   "sgsl": "申購數量",
   "bz": "幣種",
   "yebz": "USDT余額不足",
   "tgsl": "通過數量",
   "shz": "審核中",
   "wtg": "未通過",
   "ytg": "已通過"
 },
 "wydb":{
   "title": "我要貸幣",
   "db": "貸幣",
   "dbz": "貸幣中",
   "jl": "記錄",
   "jdzq": "借貸周期(天)",
   "qhk": "去還款",
   "ljdb": "累計貸幣(usdt)",
   "dhkbs" :"待還款筆數",
   "jkje": "借款金額(usdt)",
   "qsrje": "請輸入金額",
   "rll": "日利率",
   "hkfs": "還款方式",
   "dqych": "到期一次還本息",
   "lx": "利息",
   "fkjg": "放款機構",
   "tpsc": "信用貸款(圖片上傳)",
   "fwxx": "房屋信息",
   "srzm": "收入證明(雇傭關系)",
   "yhmx": "銀行明細",
   "zjz": "證件照",
   "yd": "本人已閱讀並同意",
   "xy": "申請貸幣協議",
   "sqdb": "點擊申請貸幣",
   "gb": "關閉",
   "qd": "確定",
   "ts": "請勾選申請貸幣協議",
   "dbjl": "貸幣記錄",
   "hkhth": "貸款合同號",
   "wsh": "未審核",
   "yfk": "已放款",
   "sqrq": "申請日期",
   "zq": "周期",
   "dbsl": "貸幣數量",
   "zhke": "總還款額",
   "yhkxq": "應還款詳情",
   "bqyhk": "本期應還款（USDT）",
   "hktips": "請確保余額充足，余額不足請先充值再還款",
   "bj": "本金",
   "jie": "借",
   "ljhk": "立即還款",
   "qcz": "去充值",
   "yebzqxcz": "余額不足，請先充值再還款",
   "znj": "滯納金",
   "yqts": "逾期天數"
 },
 "hkxq":{
   "dd":"訂單",
   "fzhkdz":"復製還款地址",
   "hkxq": "還款詳情",
   "zlx": "總利息",
   "zhk": "總還款",
   "hkjg": "還款機構",
   "qschkpz": "請上傳還款憑證",
   "hkpz": "還款憑證"
 },
 "bbjyNew":{
   "jylx": "交易類型",
   "jyze": "交易總額"
 },
 "indexNew":{
   "title": "添加Spmaxex到主界面",
   "t1": "快速存取 全屏幕體驗",
   "t2": "點擊下方工具欄上的",
   "t3": "並選擇",
   "t4": "添加到主屏幕",
   "t5": "添加到桌面體驗完整版Spmaxex",
   "t6": "添加到個人收藏",
   "t7": "在頁面上查找"
 },
 "bind":{
   "title": "郵箱認證",
   "ybd": "已綁定",
   "wbd": "未綁定",
   "yrz": "已認證",
   "wrz": "未認證",
   "ts": "為保護您的賬戶，建議綁定郵箱",
   "qsryxdz": "請輸入郵箱地址"
 },
 "status":{
    "statusText": ['失敗','等待處理','成功'],
 },
 "tipsNew":{
   "wjmmts": "通過驗證碼找回密碼",
   "qscpztp": "請上傳憑證圖片",
   "emailgsts": "輸入的郵箱不符合規則",
   "telgsts": "輸入的手機號碼格式有誤",
   "lcmmbyz": "兩次輸入的密碼不一致",
   "zdsl": "最低數量 ",
   "sldydy": "數量大於等於",
   "zxtzsl": "最低數量 ",
   "ddz": "等待中",
   "xs": "小時",
   "min": "最小數量 ",
   "max": "最大數量 ",
   "yebz": "余額不足",
   "qsrss": "請輸入手數",
   "zdss": "最低手數",
   "yjj": "已拒絕",
   "shz": "贖回中",
   "zwkfcz": "該幣種暫未開放充值",
   "jiaoge": "交割",
   "zhang": "漲",
   "die": "跌",
   "cjxnzh": "創建虛擬賬戶"
 },
 "langNew2":{
  "flzq": "福利專區",
  "qdjl": "簽到獎勵",
  "mrqdjl": "每日簽到獎勵",
  "qd": "簽到",
  "yqd": "已簽到",
  "hdgz": "活動規則",
  "qdjl2": "簽到記錄",
  "qdcg": "簽到成功",
  "yhd": "已獲得",
  "lq": "領取",
  "dyt": "第一天",
  "det": "第二天",
  "dst": "第三天",
  "dsit": "第四天",
  "dwt": "第五天",
  "dlt": "第六天",
  "dqt": "第七天",
  "jxz": "進行中"
},
"langNew":{
  "kp": "開盤",
  "zuoshou": "昨收",
  "zg": "最高",
  "zd": "最低",
  "dqjg": "當前價格",
  "pcjg": "平倉價格",
  "gd": "掛單",
  "gdj": "掛單價",
  "gdjg": "掛單價格",
  "xfbzj": "需付保證金：",
  "ksrfw": "可輸入範圍：",
  "shou": "手",
  "fdjyk": "浮動淨盈虧",
  "pcsl": "平倉數量",
  "cx": "撤銷",
  "qrpc": "確認平倉",
  "sx": "篩選",
  "cz": "重置",
  "zdl": "知道了",
  "kccg": "開倉成功！",
  "xzfx": "選擇方向",
  "lx": "類型",
  "xgcc": "修改持倉",
  "szzyzs": "設置止盈止損",
  "szhb": "數字貨幣",
  "gjs": "貴金屬",
  "yy": "原油",
  "jy": "交易",
  "jmhb": "加密貨幣",
  "gdsj": "掛單時間",
  "gdsl": "掛單數量",
  "fs": "time"
 },
 "ieo":{
   "ieo": "IEO",
   "csjg": "初始價格",
   "syl": "剩餘量",
   "sjd": "市價單",
   "jj": "均價",
   "zsl": "總數量",
   "zyk": "總損益",
   "ljmr": "立即買入",
   "yqx": "已取消",
   "gmjl": "購買記錄",
   "yjs": "已結束",
   "jzrq": "截止日期",
   "xjcz": "現金儲值",
   "djlxkf": "使用日圓入金，請點選聯絡客服",
   "qrrjts": "使用美元入金，請聯絡客服",
   "mmts": "只允許大小寫字母加數字組合"
  },
  "langNew4":{
    "qsrndzh": "請輸入您的帳號",
    "ljcb": "立即充幣",
    "ljtb": "立即提幣",
    "flhd": "福利活動",
    "flzx": "福利中心",
    "lqjl": "領取最高獎勵",
    "wyzq": "我已賺取",
    "hdlb": "活動列表",
    "dk": "貸款",
    "kyje": "可用金額",
    "je": "金額",
    "zd": "最大",
    "wxj": "我想藉...",
    "dkjl": "貸款記錄",
    "xydk": "信用貸款",
    "tpsc": "圖片上傳",
    "dkts": "貸款後3天內無須支付利息，之後再支付利息",
    "ljdk": "立即貸款",
    "qwc": "去完成"
  },
  share:{
    "hd": "獲得加密貨幣獎勵",
    "yqhy": "邀請您的好友參與Ai量化，租用礦機，產品交易，即可獲得加密貨幣獎勵",
    "yqsy": "邀請收益",
    "yqrs": "邀請人數",
    "yqlj": "透過連結邀請",
    "lj": "連結",
    "yqm": "邀請碼",
  },
  myAssets:{
    "cz": "儲值",
    "wzh": "為帳戶充入數位貨幣或法幣",
    "tx": "提現",
    "xyzh": "現有帳戶的資產提現到您的銀行卡或錢包",
  },
  user:{
    "zcgl": "資產管理",
    "xb": "新幣",
    "hd": "活動與獎勵",
    "zhxg": "帳戶相關",
    "kf": "客服",
    "sfrz": "身份認證",
    "aq": "安全",
    "gy": "關於",
    "sz": "設定",
    "gp": "股票",
    "wh": "外匯"
  },
  "langNew3":{
    "xw":"新聞",
    "gdgnjxz":"跟單功能進行中",
    "gdts":"開始跟單,高收益率,高回報率,讓您躺著賺幣",
    "ksgd":"開始跟單",
    "gd":"跟單",
    "gdlx1":"AI GPT",
    "gdlx2":"政治家",
    "gdlx3":"交易員",
    "npjsy":"年平均收益",
    "gtrs":"跟投人數",
    "hbl":"回報率",
    "gtje":"跟投金額",
    "gt":"跟投",
    "gdz":"跟單中",
    "ywc":"已完成",
    "zdf":"漲跌幅",
    "tz":"停止",
    "bdy":"不低於",
    "xwxq":"新聞詳情",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/tw.js